module.exports = __webpack_public_path__ + "8562891ae0379ff99ceceb5e76cc82f0.svg";